import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47a33806"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_from = _resolveComponent("el-from")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": true,
    width: "580px",
    "destroy-on-close": "",
    title: _ctx.title
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.close()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.save()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.entity)
        ? (_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            model: _ctx.entity,
            "label-position": "top",
            ref: "form"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, { gutter: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        prop: "brightness",
                        label: _ctx.$t('camera.brightness')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.entity.brightness,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entity.brightness) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        prop: "contrast",
                        label: _ctx.$t('camera.contrast')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.entity.contrast,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entity.contrast) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        prop: "saturation",
                        label: _ctx.$t('camera.saturation')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.entity.saturation,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.entity.saturation) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        prop: "hue",
                        label: _ctx.$t('camera.hue')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.entity.hue,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.entity.hue) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        prop: "autoWhiteBalanceEnabled",
                        label: _ctx.$t('camera.autoWhiteBalanceEnabled')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.entity.autoWhiteBalanceEnabled,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.entity.autoWhiteBalanceEnabled) = $event)),
                            "active-value": 1,
                            "inactive-value": 0
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        prop: "manualWhiteBalance",
                        label: _ctx.$t('camera.manualWhiteBalance')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.entity.manualWhiteBalance,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.entity.manualWhiteBalance) = $event)),
                            disabled: _ctx.entity.autoWhiteBalanceEnabled == 1
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        prop: "gamma",
                        label: _ctx.$t('camera.gamma')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.entity.gamma,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.entity.gamma) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        prop: "gain",
                        label: _ctx.$t('camera.gain')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.entity.gain,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.entity.gain) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        prop: "sharpeness",
                        label: _ctx.$t('camera.sharpeness')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.entity.sharpeness,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.entity.sharpeness) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        prop: "dirtThreshold",
                        label: _ctx.$t('camera.dirtThreshold')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.entity.dirtThreshold,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.entity.dirtThreshold) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        prop: "autoExposure",
                        class: "label-lateral"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("label", null, _toDisplayString(_ctx.$t("camera.autoExposure")), 1),
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.entity.autoExposure,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.entity.autoExposure) = $event)),
                            "active-value": 1,
                            "inactive-value": 0
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.entity && _ctx.entity.intervals)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 0,
                        span: 12
                      }, {
                        default: _withCtx(() => [
                          (_ctx.entity && _ctx.entity.intervals)
                            ? (_openBlock(), _createBlock(_component_el_from, {
                                key: 0,
                                model: _ctx.entity.intervals,
                                "label-position": "top"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "interval1",
                                    label: _ctx.$t('camera.intervals.interval1')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.entity.intervals.interval1,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.entity.intervals.interval1) = $event)),
                                        disabled: _ctx.entity.autoExposure == 1
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"]),
                                  _createVNode(_component_el_form_item, {
                                    prop: "interval2",
                                    label: _ctx.$t('camera.intervals.interval2')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.entity.intervals.interval2,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.entity.intervals.interval2) = $event)),
                                        disabled: _ctx.entity.autoExposure == 1
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"]),
                                  _createVNode(_component_el_form_item, {
                                    prop: "interval3",
                                    label: _ctx.$t('camera.intervals.interval3')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.entity.intervals.interval3,
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.entity.intervals.interval3) = $event)),
                                        disabled: _ctx.entity.autoExposure == 1
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"]),
                                  _createVNode(_component_el_form_item, {
                                    prop: "interval4",
                                    label: _ctx.$t('camera.intervals.interval4')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.entity.intervals.interval4,
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.entity.intervals.interval4) = $event)),
                                        disabled: _ctx.entity.autoExposure == 1
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }, 8, ["model"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.entity && _ctx.entity.exposures)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 1,
                        span: 12
                      }, {
                        default: _withCtx(() => [
                          (_ctx.entity && _ctx.entity.exposures)
                            ? (_openBlock(), _createBlock(_component_el_from, {
                                key: 0,
                                model: _ctx.entity.exposures,
                                "label-position": "top"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "exposure1",
                                    label: _ctx.$t('camera.exposures.exposure1')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.entity.exposures.exposure1,
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.entity.exposures.exposure1) = $event)),
                                        disabled: _ctx.entity.autoExposure == 1
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"]),
                                  _createVNode(_component_el_form_item, {
                                    prop: "exposure2",
                                    label: _ctx.$t('camera.exposures.exposure2')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.entity.exposures.exposure2,
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.entity.exposures.exposure2) = $event)),
                                        disabled: _ctx.entity.autoExposure == 1
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"]),
                                  _createVNode(_component_el_form_item, {
                                    prop: "exposure3",
                                    label: _ctx.$t('camera.exposures.exposure3')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.entity.exposures.exposure3,
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.entity.exposures.exposure3) = $event)),
                                        disabled: _ctx.entity.autoExposure == 1
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"]),
                                  _createVNode(_component_el_form_item, {
                                    prop: "exposure4",
                                    label: _ctx.$t('camera.exposures.exposure4')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.entity.exposures.exposure4,
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.entity.exposures.exposure4) = $event)),
                                        disabled: _ctx.entity.autoExposure == 1
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"]),
                                  _createVNode(_component_el_form_item, {
                                    prop: "exposure5",
                                    label: _ctx.$t('camera.exposures.exposure5')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.entity.exposures.exposure5,
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.entity.exposures.exposure5) = $event)),
                                        disabled: _ctx.entity.autoExposure == 1
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }, 8, ["model"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_col, { lg: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        prop: "filterPosition",
                        label: _ctx.$t('camera.filterPosition')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: _ctx.entity.filterPosition,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.entity.filterPosition) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                                return (_openBlock(), _createBlock(_component_el_radio, {
                                  key: option.value,
                                  label: option.label,
                                  value: option.value
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(option.label) + " º ", 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}